export default "__VITE_ASSET__CJSIZuMg__"